// extracted by mini-css-extract-plugin
export default {"registerModal":"UserRegisteredModal_registerModal__8VFd8","registerModalImage":"UserRegisteredModal_registerModalImage__2rBn1"};